// extracted by mini-css-extract-plugin
export default {"card":"ProfileCard_card__hIwa9","slide":"ProfileCard_slide__QO0Qi","side":"ProfileCard_side__ej8aV"};